import React from 'react';
import { Utils } from '../utilSMB/utils';

class ColorComp extends React.Component {
  render() {
    let colorList = [];
    let selectedColor = '';
    let styleColor = [];
    let textColor = '';
    let lytColor = [];
    let darkColor = [];
    let color;
    let prodcolor;
    this.props?.itemValue.map((itemValue, index) => {
      if (itemValue.color) {
        prodcolor = itemValue.color.replace(/\s/g, '');
      } else {
        prodcolor = itemValue.color;
      }
      if (this.props.itemValue.length === 1) {
        if (Utils.isNotNull(itemValue.color)) {
          color = itemValue.color;
          lytColor = ['Chalk', 'Lilac', 'Slate', 'White'];
          darkColor = ['Charcoal', 'Black', 'Blue', 'Gray', 'Grey', 'Silver'];
          lytColor.map((colorLyt, index) => {
            if (colorLyt === color) {
              textColor = '.bg-white';
            }
            return '';
          });
          darkColor.map((colorDark, index) => {
            if (colorDark === color) {
              textColor = 'text-white';
            }
            return '';
          });

          selectedColor = 'product-color bg-' + prodcolor.toLowerCase() + ' active ' + textColor;
          styleColor = itemValue.color;
        }
      } else if (this.props.itemValue.length > 1) {
        if (Utils.isNotNull(itemValue.color)) {
          color = itemValue.color;
          lytColor = ['Chalk', 'Lilac', 'Slate', 'White'];
          darkColor = ['Charcoal', 'Black', 'Blue', 'Gray', 'Grey', 'Silver'];
          lytColor.map((colorLyt, index) => {
            if (colorLyt === color) {
              textColor = '.bg-white';
            }
            return '';
          });
          darkColor.map((colorDark, index) => {
            if (colorDark === color) {
              textColor = 'text-white';
            }
            return '';
          });

          selectedColor =
            this.props.selectedValue.productId === itemValue.productId
              ? ' product-color  bg-' + prodcolor.toLowerCase() + ' active ' + textColor
              : 'product-color bg-' + prodcolor.toLowerCase();
          styleColor = itemValue.color;
        }
      }
      if (Utils.isNotNull(selectedColor) && selectedColor !== '') {
        colorList.push(
          <span
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <button
              className={selectedColor}
              id="prod670040_sku830084_sku830084"
              style={{ backgroundColor: styleColor }}
              title={styleColor}
              onClick={(e) => {
                this.props.colorSelection(this.props.groupId, itemValue.productId);
              }}
            ></button>{' '}
            &nbsp;
          </span>,
        );
      }
      return '';
    });

    return <React.Fragment>{colorList}</React.Fragment>;
  }
}
export default ColorComp;
